import {
  getOpenId,
  specBySpecId,
  canPrint,
  searchByKeywords,
  wxGetKey,
  eleOrder,
  elelist,
  service,
  extractCode,
  hotsearch,
  elesendEmail,
  printGetPrice,
  printGetArea,
  timeDivisions,
  getImageKey,
  createPrint,
  getOrders,
  checkMergeOrder,
  submitMergeOrder,
  requestPayment,
  getOrderDetail,
  getExpressLog,
  sendEmail,
  makephoto,
  payAgain,
  ninePic,
  getCloseList,
  getphoto,
  getprice,
  createorder,
  printImage,
  feedbackType,
  feedback,
  getTutorial,
  checkTxt,
  getUrls,
  getListHint,
  getMixOrder,
  deleteOrder,
  deleteMergeOrder,
  cancelOrder,
  makephotov1,
  asyncresult,
  makephotovJson,
  makewedding,
  asyncwedding,
  modifyAddress,
  commonSpecs, getSpecImage, gettaskid,
  print_append_order,
  getchannel,
  getOssUrl,
  PostUrl,
  picTest,
  font_test
} from '../data/api';
import { SET_LOADING, RECORD_USERINFO, RECORD_HOTSEARCH, RECORD_SERVICE_TEL, RECORD_PRICE, RECORD_PRINTPRICE } from './mutation-types';
import {
  Toast
} from "mint-ui";
import { async } from 'q';

//注意：每个actions函数超过一个参数用对象作为一个参数传

//汇总相当于每个调用接口调用之前处理的东西
function ruleFn(fn, isLoading = true) {
  return async function (...arg) {
    let { commit, state } = arg.shift();
    try {
      isLoading && commit(SET_LOADING, true);//loading开启
      await needOpenid(!state.platformInfo.openid);//是否需要获取openid
      let b = arg[0] ? fn.bind(null, arg[0]) : fn.bind(null);
      let res = await b();
      isLoading && commit(SET_LOADING, false);//loading关闭
      return res;
    } catch (e) {
      isLoading && commit(SET_LOADING, false);//loading关闭
      let message = '';
      message = typeof e === 'object' ? e.success ? '服务器异常' : e.message : e;
      console.log(message)
      Toast({
        message,
        position: 'bottom',
        duration: 4000,
        className: 'zidx9999'
      });
      return Promise.reject(message);
    }
  }
}
//此封装把actions中的参数也传给被封装的函数
function ruleNewFn(fn, isLoading = true) {
  return async function (...arg) {
    let { commit, state } = arg[0];
    try {
      isLoading && commit(SET_LOADING, true);//loading开启
      await needOpenid(!state.platformInfo.openid);//是否需要获取openid
      let b = fn.bind(null, ...arg)
      let res = await b();
      isLoading && commit(SET_LOADING, false);//loading关闭
      return res;
    } catch (e) {
      isLoading && commit(SET_LOADING, false);//loading关闭
      let message = '';
      message = typeof e === 'object' ? e.success ? '服务器异常' : e.message : e;
      return Promise.reject(message);
    }
  }
}

//是否需要获取openid
async function needOpenid(bol) {
  console.log("bol" + bol);
  bol && await getOpenId();
}
//在spec页面直接调2个接口
async function specDetail({ specid: id }) {
  let spec = specBySpecId(id);
  let canprint = canPrint(id);
  let arr = [];
  let { data: res1 } = await spec;
  let { data: res2 } = await canprint;
  arr.push(res1);
  arr.push(res2);
  return arr;
}

async function searchByKeyword(keywords) {
  return await searchByKeywords(keywords);
}

async function wxgetPhoto() {
  return await wxGetKey();
}

async function eleorder(option) {
  return await eleOrder(option);
}

async function getElelist() {
  return await elelist();
}

async function getService() {
  return await service();
}

async function getCode(option) {
  //设计两个接口一个获取code还有一个是可选接口是在支付成功跳进的页面就需要调该接口
  let { payenter, order_id } = option
  let arr = []
  let ec = extractCode({ order_id })
  let bb = payenter ? getUrls(order_id) : "不是支付完成直接进的";
  let { data: res } = await ec;
  arr.push(res);
  if (payenter) {
    let obj = await bb;
    arr.push(obj.data)
  }
  return arr;
}

async function getHot() {
  return await hotsearch();
}

async function sendeleEmail(option) {
  return await elesendEmail(option);
}

async function getPrintPrice() {
  return await printGetPrice()
}

async function getDivisions() {
  return await printGetArea();
}

async function getDivisionTime(option) {
  return await timeDivisions(option);
}

async function createPrintOrder({ state,commit }, {
  colors, origin_name, spec_id, consignee_name, spec_name, consignee_phone, print_number, ele_name,
  delivery, description, quantity, user_name, user_phone, user_address_division, user_address_detail, is_formal_wear, extra,add_order_image_key,add_order_specs
}) {

  let { data: { image_key } } = await getImageKey({
    colors, origin_name, spec_id, consignee_name, spec_name, consignee_phone, print_number, ele_name
  });
  let res = await createPrint({
    delivery, description, quantity, user_name, extra, user_phone, user_address_division, user_address_detail, image_key, ...is_formal_wear && { is_formal_wear: 'true' },
    ...add_order_image_key&&{add_order_image_key},
    ...add_order_specs&&{add_order_specs}
  })
  commit('EXTRAINIT')
  return res
}

async function getPrintList(option) {
  return await getOrders(option)
}

async function checkOrder(data) {
  return await checkMergeOrder(data);
}

async function smo(data) {
  return await submitMergeOrder(data);
}

async function printPay(data) {
  return await requestPayment(data);
}

async function getOrderDetailAndLog(data) {
  let detail = getOrderDetail(data);//获取订单详情
  let expressLog = getExpressLog(data);//获取快递信息
  return [await detail, await expressLog];
}

async function sendPrintEmail(data) {
  return await sendEmail(data);
}

async function makephotos(data) {
  return await makephoto(data);
}

async function rePay(data) {
  return await payAgain(data);
}

async function HotPic() {
  return await ninePic();
}

async function getfeedbackType() {
  return await feedbackType();
}

async function closeList() {
  return await getCloseList();
}

async function gotphoto(data) {
  return await getphoto(data);
}

async function gotprice() {
  return await getprice();
}

async function getorder(data) {
  return await createorder(data).then(res=>{
    let { data:{order_id} } = res
    window._webTrack && window._webTrack.trackCustom('GENERATE_ORDER',{order_id})
    return res
  })
}

async function getprint(data) {
  return await printImage(data);
}

async function getWmPrintAndKey({ state, commit }, data) {
  let {
    bgColor,
    platformInfo: {
      appId,
      openid
    },
    processedPhoto: {
      backcolor,
      specId,
      picinfo: {
        beauty_level = 1,
        ori_file_name,
        type
      }
    }
  } = state
  let d = {
    app_id: appId,
    openid,
    spec_id: specId,
    beauty_level,
    ori_file_name
  }
  console.log("lalalla:::", state)
  let res_p = printImage(data)
  let res2_p = print_append_order(d)
  let [res, res2] = await Promise.all([res_p, res2_p])
  let {
    data: {
      extra = {}
    }
  } = res2
  extra.color = backcolor[bgColor].color_name
  commit('SETPRINTEXTRA', {
    ...extra,
    ...state.extraInfo,
    phototype: type
  })
  return res
}

async function sendFeedback(data) {
  return await feedback(data);
}

async function getGuide() {
  return await getTutorial()
}

async function checktxt(txt) {
  return await checkTxt(txt)
}

async function getListHintA() {
  return await getListHint()
}

function diguigetCutResult(data, resolve, reject) {
  return asyncresult(data).then(res => {
    console.log("res::::", res)
    if (res.data.code === 202) {
      setTimeout(() => {
        return diguigetCutResult(data, resolve, reject)
      }, 500)
      return
    }
    resolve(res)
  }).catch(err => {
    reject(err)
  })
}

function asyncMakephotoJson(store, data) {
  let { state } = store
  return ruleFn((data) => {
    const { openid } = state.platformInfo
    return new Promise((resolve, reject) => {
      makephotovJson(data).then(res => {
        const { task_id_list } = res.data
        const data1 = {
          task_id_list,
          openid
        }
        setTimeout(() => {
          diguigetCutResult(data1, resolve, reject)
        }, 1500)
      })
    })
  })(store, data)
}

function asyncMakephoto(store, data) {
  let { state } = store
  return ruleFn((data) => {
    const { openid } = state.platformInfo
    return new Promise((resolve, reject) => {
      makephotov1(data).then(res => {
        const { task_id_list } = res.data
        const data1 = {
          task_id_list,
          openid
        }
        setTimeout(() => {
          diguigetCutResult(data1, resolve, reject)
        }, 1500)
      })
    })
  })(store, data)
}

function diguigetWeddingResult(data, resolve, reject) {
  return asyncwedding(data).then(res => {
    console.log("res::::", res)
    if (res.data.code === 202) {
      setTimeout(() => {
        return diguigetWeddingResult(data, resolve, reject)
      }, 500)
      return
    }
    resolve(res)
  }).catch(err => {
    reject(err)
  })
}

function asyncWeddingMakephoto(store, data) {
  let { state } = store
  return ruleFn((data) => {
    const { openid } = state.platformInfo
    return new Promise((resolve, reject) => {
      makewedding(data).then(res => {
        const { task_id_list } = res.data
        const data1 = {
          task_id_list,
          openid
        }
        setTimeout(() => {
          diguigetWeddingResult(data1, resolve, reject)
        }, 1500)
      })
    })
  })(store, data)
}

function modifyAddressA(data) {
  let { orderid, user_address_division, user_name, user_phone, user_address_detail } = data
  return modifyAddress(orderid, user_address_division, user_name, user_phone, user_address_detail)
}

function getSpecs({ state, commit }, spec_id) {
  let d = state.extraRule[spec_id]
  let {
    processedPhoto:{
      specName:spec_name
    },
    printextra:{
      color:maincolor
    }
  } = state
  if (d) {
    commit('SETRULECOLOR', d)
    return Promise.resolve(d)
  }
  return commonSpecs({ spec_id, spec_name }).then(res => {
    console.log("res:::", res)
    let { data } = res
    for (let i = 0, len = data.length; i < len; i++) {
      let specobj = data[i]
      if (specobj.id === +spec_id) {
        data[i].colors = specobj.colors.filter(item => item.color_name !== maincolor)
        break;
      }
    }
    state.extraRule[spec_id] = data
    commit('SETRULECOLOR', data)
    return data
  })
}

function getlunxun(id) {
  return new Promise((resolve, reject) => {
    gettaskid(id).then(res => {
      let { data: { state, result } } = res
      let obj = {
        'running': () => {
          setTimeout(() => {
            return resolve(getlunxun(id))
          }, 500)
        },
        'failed': () => {
          return reject(result.message)
        },
        'completed': () => {
          let {message} = result
          if(message){
            return reject(message)
          }
          return resolve(result)
        }
      }
      return obj[state] && obj[state]()
    })
  })
}

function getAutoImage({ state }, data) {
  //data-{spec_id:12,image_key:''}
  let { spec_id, image_key } = data
  let d = state.kouStore[image_key + spec_id]
  if (d) {
    console.log("拿到缓存了")
    return Promise.resolve(d)
  }
  return getSpecImage(data).then(res => {
    console.log("获取任务id:::", res)
    let { data: { id } } = res
    return getlunxun(id)
  }).then(res => {
    state.kouStore[image_key + spec_id] = res
    return res
  })
}

// function setExtraInfoM({ state }, file_path) {
//   let data = {
//     file_path,
//     parameter: state.grouplist.map(item => ({
//       spec_id: item.id,
//       colors: (state.ruleColor[item.id])[item.colorIdx],
//       print_number: item.printQty
//     }))
//   }
//   return setExtraInfo(data)
// }

function getchannelM({ state }) {
  return getchannel().then(res => {
    let { data: { state: str } } = res
    state.extraAddState = str
    return str
  })
}

function getOssImageKey(file){
  return getOssUrl().then(res=>{
    console.log("oss:::",res)
    let {data:{
      upload:{
        OSSAccessKeyId,
        dir,
        host,
        key,
        policy,
        signature
      }
    }} = res
    let fd = new FormData();
    fd.append('key',dir);
    fd.append('OSSAccessKeyId',OSSAccessKeyId);
    fd.append('policy',policy);
    fd.append('signature',signature);
    fd.append('success_action_status',200);
    fd.append('file',file);
    return PostUrl(host,fd).then(res=>{
      return picTest(key).then(res=>{
        let {data:{is_permit}} = res;
        if(is_permit){
          return true
        }
        throw "图片存在敏感信息"
      })
    })
  })
}

function font_testS(text){
  return font_test(text).then(res=>{
    let {data:{is_permit}} = res
    if(is_permit){
      return true
    }
    throw "文字存在敏感信息"
  })
}

export default {
  specDetail: ruleFn(specDetail),
  searchByKeywords: ruleFn(searchByKeyword),
  wxgetPhoto: ruleFn(wxgetPhoto),
  eleorder: ruleFn(eleorder),
  getElelist: ruleFn(getElelist),
  getService: ruleFn(getService),
  getCode: ruleFn(getCode, false),
  getHot: ruleFn(getHot),
  sendeleEmail: ruleFn(sendeleEmail),
  getPrintPrice: ruleFn(getPrintPrice),
  getDivisions: ruleFn(getDivisions),
  getDivisionTime: ruleFn(getDivisionTime, false),
  getPrintList: ruleFn(getPrintList, false),
  checkOrder: ruleFn(checkOrder),
  smo: ruleFn(smo),
  printPay: ruleFn(printPay),
  getOrderDetailAndLog: ruleFn(getOrderDetailAndLog),
  sendPrintEmail: ruleFn(sendPrintEmail),
  makephotos: ruleFn(makephotos),
  rePay: ruleFn(rePay),
  HotPic: ruleFn(HotPic),
  closeList: ruleFn(closeList),
  gotphoto: ruleFn(gotphoto),
  gotprice: ruleFn(gotprice),
  getorder: ruleFn(getorder),
  getprint: ruleFn(getprint),
  getfeedbackType: ruleFn(getfeedbackType),
  sendFeedback: ruleFn(sendFeedback),
  getGuide: ruleFn(getGuide),
  checktxt: ruleFn(checktxt),
  getListHintA: ruleFn(getListHintA, false),
  getMixOrder: ruleFn(getMixOrder),
  deleteOrderA: ruleFn(deleteOrder),
  deleteMergeOrder: ruleFn(deleteMergeOrder),
  cancelOrderA: ruleFn(cancelOrder),
  asyncMakephoto,
  asyncMakephotoJson,
  asyncWeddingMakephoto,
  modifyAddressA: ruleFn(modifyAddressA),
  getSpecs: ruleNewFn(getSpecs),
  getAutoImage: ruleNewFn(getAutoImage),
  getWmPrintAndKey: ruleNewFn(getWmPrintAndKey),
  createPrintOrder: ruleNewFn(createPrintOrder),
  getchannelM: ruleNewFn(getchannelM),
  getOssImageKeyM: ruleFn(getOssImageKey),
  font_testM:ruleFn(font_testS)
}